// Unsent chat messages, one per conversation, kept in this browser (localStorage) so they survive a reload and
// show in every open tab: a tab writing a draft updates the same conversation in the others (storage event).
// Per account and operator; never sent to the server, so other people and devices don't see them.
const PREFIX = "chatDraft:";
const MAX_AGE_MS = 14 * 864e5;

const userOf = () => {
    try {
        return window.sessionStorage.getItem("sub") || "me";
    } catch (e) {
        return "me";
    }
};

export const draftKey = (account, clientNumber) =>
    clientNumber ? `${PREFIX}${account || "-"}:${userOf()}:${clientNumber}` : null;

const parse = raw => {
    try {
        const value = JSON.parse(raw);
        return value && typeof value.text === "string" ? value : null;
    } catch (e) {
        return null;
    }
};

export const readDraft = key => {
    if (!key) return "";
    try {
        const value = parse(window.localStorage.getItem(key));
        if (!value) return "";
        if (Date.now() - (value.at || 0) > MAX_AGE_MS) {
            window.localStorage.removeItem(key);
            return "";
        }
        return value.text;
    } catch (e) {
        return "";
    }
};

export const writeDraft = (key, text) => {
    if (!key) return;
    try {
        if (text) window.localStorage.setItem(key, JSON.stringify({text, at: Date.now()}));
        else window.localStorage.removeItem(key);
    } catch (e) {
        // Storage full or blocked: the draft just lives in this tab.
    }
};

// Text from a storage event for this key ("" when it was removed or sent), or null for other keys.
export const draftFromEvent = (event, key) => {
    if (!key || !event || event.key !== key) return null;
    return event.newValue ? (parse(event.newValue)?.text || "") : "";
};

// Drop drafts older than MAX_AGE_MS (once per page load).
export const pruneDrafts = () => {
    try {
        const now = Date.now();
        for (let i = window.localStorage.length - 1; i >= 0; i--) {
            const key = window.localStorage.key(i);
            if (!key || !key.startsWith(PREFIX)) continue;
            const value = parse(window.localStorage.getItem(key));
            if (!value || now - (value.at || 0) > MAX_AGE_MS) window.localStorage.removeItem(key);
        }
    } catch (e) {
        // Nothing to clean when storage is not available.
    }
};
